import { render, staticRenderFns } from "./OzPopoverTip.vue?vue&type=template&id=79c081f6&"
import script from "./OzPopoverTip.vue?vue&type=script&lang=ts&"
export * from "./OzPopoverTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports